module.exports = __webpack_public_path__ + "img/S.6d06d548.png";